const template = document.createElement('template');
template.innerHTML = `
<style>
    :host {
        display: inline-block;
        font-family: 'Courier New', Courier, monospace;
        user-select: none;
    }
    .container {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        background: rgba(255, 255, 255, 0.05);
        padding: 4px 8px;
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        transition: all 0.2s;
    }
    .container:hover {
        background: rgba(255, 255, 255, 0.1);
        border-color: rgba(255, 255, 255, 0.3);
    }
    .label {
        font-size: 0.8rem;
        color: #aaa;
        font-weight: bold;
    }
    .switch {
        position: relative;
        width: 30px;
        height: 16px;
        background: #333;
        border-radius: 8px;
        transition: background 0.3s;
    }
    .knob {
        position: absolute;
        top: 2px;
        left: 2px;
        width: 12px;
        height: 12px;
        background: #fff;
        border-radius: 50%;
        transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
        box-shadow: 0 1px 3px rgba(0,0,0,0.5);
    }
    :host([active]) .switch {
        background: var(--primary-color, #00ffcc);
    }
    :host([active]) .knob {
        transform: translateX(14px);
    }
    :host([active]) .label {
        color: #fff;
        text-shadow: 0 0 5px var(--primary-color, #00ffcc);
    }
</style>
<div class="container">
    <div class="label" id="label">MONO</div>
    <div class="switch">
        <div class="knob"></div>
    </div>
</div>
`;

export class ToggleSwitch extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.container = this.shadowRoot.querySelector('.container');
        this.labelEl = this.shadowRoot.getElementById('label');
        
        this.container.addEventListener('click', () => this.toggle());
    }

    static get observedAttributes() {
        return ['label-on', 'label-off', 'active'];
    }

    attributeChangedCallback(name, oldVal, newVal) {
        this.render();
    }

    get active() {
        return this.hasAttribute('active');
    }

    set active(val) {
        if (val) this.setAttribute('active', '');
        else this.removeAttribute('active');
    }

    toggle() {
        this.active = !this.active;
        this.dispatchEvent(new Event('change', { bubbles: true }));
    }

    render() {
        const labelOn = this.getAttribute('label-on') || 'ON';
        const labelOff = this.getAttribute('label-off') || 'OFF';
        this.labelEl.textContent = this.active ? labelOn : labelOff;
    }
}

customElements.define('toggle-switch', ToggleSwitch);
